<div class="grid-container margin-top">
  <div class="grid-x">
    @if (!paymentsLoading) {
      <div class="cell large-8 medium-8 small-8 bold red italic">
        To limit concurrency, receipts/invoices will be submitted in batches of {{batchLimit}} at a time.
      </div>
      <div class="cell large-4 medium-4 small-4 bold red">
        @if (batchCount > 0 && currentBatch > 0) {
          Processing batch #{{currentBatch}} of {{batchCount}}.
        }
      </div>
      <div class="cell large-8 medium-8 small-8 bold">
        Receipts / Invoices to Reproduce:
      </div>
      <div class="cell large-4 medium-4 small-4 bold">
        Submission Status:
      </div>
      @if (queueIdentifiers == null || queueIdentifiers.length == 0) {
        No matching payment data found.
      }
      @for (id of queueIdentifiers; track id) {
        @if (getPaymentsByIdentifier(id).length > 0) {
          <div class="cell large-8 medium-8 small-8">
            <receipt [queueIdentifier]="id"
              [applicationNumber]="getApplicationNumberByIdentifier(id)"
              [autoGeneratePdf]="false"
              [isPaid]="receiptIsPaid(id)"
              [shrinkFont]="false"
              [isCredit]="false"
              [records]="getPaymentsByIdentifier(id)"
              [isSinglePaymentType]="false"
              [unpaidRecordStatuses]="unpaidStatuses"
              [hasPartials]="false"
              [showButtons]="false">
            </receipt>
          </div>
          <div class="cell large-4 medium-4 small-4 bold padding-left">
            @switch (getSubmissionStatus(id)) {
              @case (statuses.InProcess) {
                <span class="blue">
                  <text-loader [run]="true" [text]="statuses.InProcess" [tickType]="'.'" [interval]="3000"></text-loader>
                </span>
              }
              @case (statuses.Success) {
                <span class="green">
                  {{statuses.Success}}
                </span>
              }
              @case (statuses.Error) {
                <span class="red">
                  {{statuses.Error}}
                </span>
              }
              @default {
                <span>
                  {{statuses.Unsubmitted}}
                </span>
              }
            }
          </div>
        }
      }
    } @else {
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="paymentsLoading" [text]="'Loading Invoice / Receipt Data'" [tickType]="'.'" [interval]="1000"></text-loader>
      </div>
    }
  </div>
</div>

